/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { TweenLite } from 'gsap';
import { useLocation } from "@reach/router"
import { StaticQuery, graphql } from "gatsby";
import { Contact, SingleProduct, OpenNavbar, NutritionalFacts } from './';
import Header from "./Header"
import BimboLogo from '../images/bimbo_logo.png';
import "./layout.css"

const Layout = ({ children, image }) => {

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    var html = document.documentElement;
    var body = document.body;

    var scroller = {
      target: document.querySelector("#scrolling"),
      ease: 0.05, // <= scroll speed
      endY: 0,
      y: 0,
      resizeRequest: 1,
      scrollRequest: 0,
    };

    var requestId = null;

    TweenLite.set(scroller.target, {
      rotation: 0.01,
      force3D: true
    });

    window.addEventListener("load", onLoad);

    function onLoad() {
      updateScroller();
      window.focus();
      window.addEventListener("resize", onResize);
      document.addEventListener("scroll", onScroll);
    }

    function updateScroller() {

      // var resized = scroller.resizeRequest > 0;

      // if (resized) {
      //   var height = scroller.target.clientHeight;
      //   body.style.height = height + "px";
      //   scroller.resizeRequest = 0;
      // }

      var scrollY = window.pageYOffset || html.scrollTop || body.scrollTop || 0;

      scroller.endY = scrollY;
      scroller.y += (scrollY - scroller.y) * scroller.ease;

      if (Math.abs(scrollY - scroller.y) < 0.05 || resized) {
        scroller.y = scrollY;
        scroller.scrollRequest = 0;
      }

      TweenLite.set(scroller.target, {
        y: -scroller.y
      });

      requestId = scroller.scrollRequest > 0 ? requestAnimationFrame(updateScroller) : null;
    }

    function onScroll() {
      scroller.scrollRequest++;
      if (!requestId) {
        requestId = requestAnimationFrame(updateScroller);
      }
    }

    function onResize() {
      scroller.resizeRequest++;
      if (!requestId) {
        requestId = requestAnimationFrame(updateScroller);
      }
    }
  })

  return (
    <StaticQuery
      query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
      render={data => (
        <div style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Header />
          <div
            style={{
              flex: 1,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative'
            }}
          >
            <OpenNavbar
              delayTime={300} />
            <div
              id="scrolling"
              style={{
                flex: 1,
                position: 'relative',
                overflow: 'auto',
              }}>
              {children}
            </div>
          </div>
          <NutritionalFacts />
          <Contact logo={BimboLogo} />
          <SingleProduct />
        </div>
      )}
    />
  )
}


Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
